export default __webpack_public_path__ + "static/media/preflop-equity-handvsrange_0003_thumb.a6108db5.jpg";